export const currencyIDR = value =>
  new Intl.NumberFormat("en-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0
  }).format(value);
